import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=e709095a"
var script = {}
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=e709095a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports